export default "__VITE_ASSET__DigVr3Vf__"